import React from "react"

import LedgerAccountTable from "./components/LedgerAccountTable"
import LedgerAccountForm from "./components/LedgerAccountForm"
import ImportForm from "../../imports/ImportForm"
import BulkEditForm from "../../bulkEdit/bulkEditForm"

export default function LedgerAccountPage({ view, recordSelected = null }) {
    console.log(view)
    const renderView = () => {
        switch (view) {
            case "index":
                return renderIndex()
            case "import":
                return renderImport()    
            case "form":
                return renderForm()
            case 'bulk_edit':
                return renderBulkEdit()
            default:
                return renderIndex()
        }
    }

    const renderIndex = () => {
        return <LedgerAccountTable />
    }

    const renderImport = () => {
        return <ImportForm dataType="ledger_account" />
    }

    const renderForm = () => {
        if (recordSelected) {
            return <LedgerAccountForm actionName="edit" />
        }

        return <LedgerAccountForm actionName="new" />
    }

    const renderBulkEdit = () => {
        return <BulkEditForm dataType="ledgerAccount" />
    }

    return <>{renderView()}</>
}
